import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      try { await api.post("/auth/refresh"); const { data } = await api.get("/auth/me"); setUser(data); }
      catch { setUser(false); }
    }
  }, []);

  useEffect(() => {
    // Skip /me while returning from Google OAuth: AuthCallback exchanges the session first
    if (window.location.hash?.includes("session_id=")) { setUser(false); return; }
    refresh();
  }, [refresh]);

  const login = async (email, password) => { const { data } = await api.post("/auth/login", { email, password }); setUser(data); return data; };
  const register = async (payload) => { const { data } = await api.post("/auth/register", payload); setUser(data); return data; };
  const logout = async () => { await api.post("/auth/logout"); setUser(false); };
  const isStaff = !!user && user.role && user.role !== "customer";

  return <AuthCtx.Provider value={{ user, setUser, login, register, logout, refresh, isStaff }}>{children}</AuthCtx.Provider>;
}
